import React from 'react';
import { CircularProgress } from '@mui/material';

const LoadingSpinner: React.FC = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '4rem' }}>
      <CircularProgress size={32} thickness={4} sx={{ color: 'var(--accent-primary)' }} />
    </div>
  );
};

export default LoadingSpinner;
